import { useEffect, useRef } from "react";

import { useRouter } from "@uirouter/react";

export const useAutoScrollTop = <T extends HTMLElement = HTMLDivElement>() => {
    const elementRef = useRef<T>(null);
    const handler = useRef<(() => void) | null>(null);
    const router = useRouter();

    useEffect(() => {
        handler.current = router.transitionService.onSuccess({}, (transition) => {
            const element = elementRef.current;
            const fromState = transition.from();
            const toState = transition.to();

            if (element && !transition.dynamic() && fromState.name !== toState.name) {
                setTimeout(() => {
                    if (element.scrollHeight > element.clientHeight) {
                        element.scrollTop = 0;
                    }
                }, 200);
            }
        }) as () => void;
        // clean up
        return () => {
            if (typeof handler?.current === "function") {
                handler.current();
            }
        };
    }, []);

    return elementRef;
};
